var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c("v-toolbar-title", [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _vm.icon
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "vertical-align": "middle",
                              },
                            },
                            [
                              _c("v-icon", { attrs: { "x-large": "" } }, [
                                _vm._v(_vm._s(_vm.icon)),
                              ]),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "headline",
                        staticStyle: {
                          display: "inline-block",
                          "vertical-align": "middle",
                          "padding-left": "20px",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(_vm.title) + "\n          "
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$emit("onCancelClicked")
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "px-5": "", "py-2": "" } },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }